/**
 * Configuración base para Jodit Editor
 * Define las configuraciones estándar para el editor de texto enriquecido
 */

export const JODIT_BASE_CONFIG = {
  language: "es",
  toolbar: true,
  toolbarSticky: true,
  toolbarButtonSize: "middle" as const,
  showCharsCounter: true,
  showWordsCounter: true,
  showXPathInStatusbar: false,
  useSplitMode: false,
  allowResizeY: false,
  askBeforePasteHTML: false,
  allowResizeX: false,
  addNewLine: false,
  safePluginsList: ["table"],
  disablePlugins: [
    "poweredByJodit",
    "video",
    "image",
    "file",
    "print",
    "fullsize",
    "source",
    "about",
    "resize",
    "speech-recognize"
  ]
};

export const JODIT_BUTTONS = [
  "undo",
  "redo",
  "|",
  "bold",
  "align",
  "underline",
  "strikethrough",
  "ul",
  "outdent",
  "indent",
  "paragraph"
  // Botones comentados para futuras implementaciones:
  // "italic", "eraser", "ol", "fontsize", "brush", "link", "table"
];
